import {User} from "./admin/users/user.model";

export class Category {
  constructor(public id: number, 
              public name:string, 
              public hasSubCategory: boolean,
              public parentId: Category){ }
}

export class ProductResponse{
    object_list: Product[];
    page_size: number;
}
export class Product {
    public static isWithin120Days(createTime: string): boolean {
        const creationDate = new Date(createTime);
        const currentDate = new Date();
        const difference = currentDate.getTime() - creationDate.getTime();
        const daysDifference = difference / (1000 * 60 * 60 * 24);
        return daysDifference <= 120;
    }
  constructor(public id: number,
              public name: string,
              public images: Array<any>,
              public supplierPrice?: number,
              public clientPrice?: number,
              public discount?: number,
              public ledType?: string,
              public barCode?: string,
              public generatedBarcode?: string,
              public  workHours?: string,
              public ledPower ?:string,
              public quantity ?:number,
              public ratingsCount?: number,
              public ratingsValue?: number,
              public description?: string,
              public availibilityCount?: number,
              public cartCount?: number,
              public color?: Color[],
              public size?: Array<string>,
              public weight?: number,
              public mainCategory?:Category | number,
              public categoryId?: number){ }
              public lumen?: number;
              public lighting?: string;
              public bottomIlluminationAngle?: number;
              public upperIlluminationAngle?: number;
              public lightBulbHouse?: string;
              public lightBulb?: string;
              public height?: number;
              public width?: number;
              public length?: number;
              public lightHue?: string;
              public ip?: number;
              public voltage?: string;
              public building?: string;
              public cover?: string;
              public illuminationAngles?: number;
              public depth?: number;
              public diameter?: number;
              public bore?: number;
              public cri?: number;
              public lm?: number;
              public deviceStatus?: string;
              public createTime?: string;
              public updateTime?: string;
              public selectedColor?: Color[];
              public expireDate?: number
              public column?: number;
              public row?: number;
              public layer?: number;
              public image?: number;
              public scannedTime?: number

}
export class Banner{
    constructor(
        public id: number,
        public title: string,
        public subtitle: string,
        public link: string,
        public image: string,
    ) {}
}
export class VideoBackground{
    constructor(
        public id: number,
        public description: string,
        public title: string,
        public videoSrc: string,
        public mobileSrc: string
    )
    {}
}
export class Slider{
    constructor(
        public id: number,
        public title: string,
        public subtitle: string,
        public link: string,
        public image: string,
        public sortNumber: number
    ) {}
}
export class Brands {
    constructor(
        public name: string,
        public image: string,
    ){ }
}
export class Size {
    constructor(
        public size: number,
    ){ }
}
export class Color {
    public count!: number
    constructor(
        public id: string,
        public name: string,
        public code: string,
        public selected: boolean,
        public image: string
    ){ }
}

export class PaymentMethod{
    constructor(
        public user: User,
        public cardHolderName: string,
        public cardNumber: string,
        public expiredMonth: number,
        public expiredYear: number,
        public cvv: string,
    ) {}

}
export class OrderItem{
    constructor(
        public product: Product,
        public quantity: number,
        public freeText: string,
    ) {}
}

export class Order{
    constructor(
        public number: number | null,
        public submittedDate: string  | null,
        public user: User  | null,
        public paymentMethod: PaymentMethod  | null,
        public totalPrice: number  | null,
        public status: string | null,
        public paymentStatus: string | null,
        public orderItem: OrderItem[]  | null,
        public firstName: string  | null,
        public lastName: string  | null,
        public email: string  | null,
        public phone: string  | null,
        public deliveryOption1: string | null,
        public deliveryOption2: string | null,
        public deliveryOption3: string | null
    ) {}
}
